import * as yup from 'yup';
import { FobGasType, FobStatus, FobType } from '../types';

export const createFobDialogSchema = yup.object().shape({
  venueId: yup.string().nullable().default(null).label('Venue id'),
  remoteCoolerIds: yup.array().of(yup.string().required()).nullable().default(null).label('Remote coolers'),
  status: yup.mixed<FobStatus>().oneOf(Object.values(FobStatus)).required().label('Status'),
  type: yup.mixed<FobType>().oneOf(Object.values(FobType)).nullable().default(null).label('Type'),
  gasType: yup.mixed<FobGasType>().oneOf(Object.values(FobGasType)).nullable().default(null).label('Gas type'),
  position: yup.number().required().label('Position'),
  productId: yup.string().nullable().default(null).label('Product'),
  cellarId: yup.string().required().label('Cellar'),
  pump: yup.boolean().required().label('Pump'),
  shiftFobs: yup.boolean().nullable().default(null).label('Shift fobs')
});

export const updateFobDialogSchema = yup.object().shape({
  fobId: yup.string().nullable().default(null).label('Fob id'),
  venueId: yup.string().nullable().default(null).label('Venue id'),
  remoteCoolerIds: yup.array().of(yup.string().required()).nullable().default(null).label('Remote coolers'),
  status: yup.mixed<FobStatus>().oneOf(Object.values(FobStatus)).required().label('Status'),
  type: yup.mixed<FobType>().oneOf(Object.values(FobType)).nullable().default(null).label('Type'),
  gasType: yup.mixed<FobGasType>().oneOf(Object.values(FobGasType)).nullable().default(null).label('Gas type'),
  position: yup.number().required().label('Position'),
  productId: yup.string().nullable().default(null).label('Product'),
  cellarId: yup.string().required().label('Cellar'),
  pump: yup.boolean().required().label('Pump'),
  shiftFobs: yup.boolean().nullable().default(null).label('Shift fobs')
});

export const createBulkFobsDialogSchema = yup.object().shape({
  cellarId: yup.string().required().label('Cellar'),
  quantity: yup.number().required().label('Quantity'),
  pump: yup.boolean().required().label('Pump'),
  remoteCoolerIds: yup.array().of(yup.string().required()).nullable().default(null).label('Remote coolers'),
  status: yup.mixed<FobStatus>().oneOf(Object.values(FobStatus)).required().label('Status'),
  type: yup.mixed<FobType>().oneOf(Object.values(FobType)).nullable().default(null).label('Type'),
  gasType: yup.mixed<FobGasType>().oneOf(Object.values(FobGasType)).nullable().default(null).label('Gas type'),
  productId: yup.string().nullable().default(null).label('Product')
});
